import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { BootstrapVue, IconsPlugin,BootstrapVueIcons } from 'bootstrap-vue'
import checkToken from './service/status';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import './assets/custom.scss';
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import VueGtag from "vue-gtag";
// import VueFbCustomerChat from 'vue-fb-customer-chat'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(BootstrapVueIcons)
Vue.use(VueAxios, axios)
Vue.use(Datetime)
Vue.use(VueGtag, {config:{id: 'UA-83601227-7'}})
// Vue.use(VueFbCustomerChat, {
//   page_id: '', //  change 'null' to your Facebook Page ID,
//   theme_color: '#333333', // theme color in HEX
//   locale: 'en_US', // default 'en_US'
// })

router.beforeEach((to, from, next) => {
  if (to.fullPath === '/login') {
    checkToken()
      .then(() => {

        next({path: '/home'})
      })
      .catch(() => {

        next();
      })
  }else if (to.fullPath === '/home') {
    checkToken()
      .then(() => {
        next()
      })
      .catch(() => {
        next();
      })
  }else{
    if (to.matched.some(record => record.meta.requiresAuth)) {
      checkToken()
        .then(() => {
          next()
        })
        .catch(() => {
          next({path: '/login'});
        })

    } else {
      next();
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
